import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const gameVuex = createNamespacedHelpers("game");
const taskVuex = createNamespacedHelpers("task");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "userCenter",
  inject: ["setPopEnoughShow"],
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo", "didInfo", "settingInfo"]),
    ...taskVuex.mapState(["taskInfo"]),
    ...gameVuex.mapState(["gameProgress"]),
    ...walletVuex.mapState(["tonConnect"])
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          await this.initFn();
        }
      },
      deep: true,
      immediate: true
    },
    popPromptShow: {
      handler(bool) {
        if (!bool) {
          this.selectRow = null;
          this.mediaInput = "";
          this.isEdit = true;
          clearTimeout(this.tonnectTimer);
          this.popPromptInfo = null;
        }
      }
    }
  },
  data() {
    return {
      popPromptShow: false,
      //是否显示公共弹窗状态
      popPromptInfo: null,
      //存储公共弹窗的页面信息
      mediaInput: "",
      isEdit: true,
      selectRow: null,
      tonnectTimer: null
    };
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.tonnectTimer);
    next();
  },
  methods: {
    ...userVuex.mapActions(["getDidInfo", "completeDidTask", "editDidTask"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    async initFn() {
      console.log("getDidInfogetDidInfogetDidInfogetDidInfo", this.didInfo);
      // this.didInfo = await this.getDidInfo();
    },

    onShowPop(item) {
      const setConfirmTextFnc = itm => {
        if (!itm.editable) {
          return null;
        }
        if (itm.type === "wallet" && itm.title == "TON" && !this.tonConnect) {
          if (!itm.completed) {
            return "Connect";
          }
          return "Reconnect";
        }
        if (!itm.completed) {
          return "Submit";
        }
        return "Resubmit";
      };
      const setIsDisableConfirmFnc = itm => {
        if (itm.type === "wallet" && itm.title == "TON") {
          return;
        }
        if (!itm.value) {
          return true;
        }
        if (itm.completed === 1 && this.isEdit) {
          return true;
        }
        return !Boolean(itm.value);
      };
      const confirmFn = async itm => {
        if (itm.type === "wallet" && itm.title == "TON") {
          if (!this.tonConnect) {
            await this.walletConnect(itm);
            return;
          }
        }
        if (itm.completed) {
          if (this.userInfo.coin < item?.edit_costs?.coin) {
            this.setPopEnoughShow();
            return;
          }
          await this.editFrom(itm);
          return;
        }
        this.submitFrom(itm);
      };
      const setMediaInputFnc = itm => {
        if (itm.type === "wallet" && itm.title == "TON" && this.tonConnect) {
          clearTimeout(this.tonnectTimer);
          return this.tonWallet.uiAddress;
        }
        if (itm.value) {
          return itm.value;
        }
        return "";
      };
      const setSubInfoFnc = itm => {
        const arr = [{
          title: "Telegram",
          sub: "Improve Telegram to get rewards"
        }, {
          title: "Meta",
          sub: "Get rewards for improving Meta"
        }, {
          title: "Tiktok",
          sub: "Perfect Tiktok rewards"
        }, {
          title: "Youtube",
          sub: "Improve Youtube to get rewards"
        }, {
          title: "X",
          sub: "Improve X to get rewards"
        }, {
          title: "TON",
          sub: "Connect your TON wallet address to get rewards"
        }, {
          title: "ETH",
          sub: "Connect your ETH wallet address to get rewards"
        }, {
          title: "BSC",
          sub: "Connect your BSC wallet address to get rewards"
        }, {
          title: "Solana",
          sub: "Connect your SOLANA wallet address to get rewards"
        }];
        const _arr = arr.filter(it => it.title == itm.title);
        if (_arr.length) {
          return _arr[0].sub;
        } else {
          return `Get rewards for improving ${itm.title}`;
        }
      };
      const popPromptInfo = {
        icon: item.icon,
        title: item.title,
        sub: setSubInfoFnc(item),
        info: item.type == 'social' ? `Contact infomatlon for reward issuance confirmation` : `The ${item.title} is used to receive airdrop rewards.`,
        reward: (item.reward ? `<i style="display: flex;align-items: center;"><img src="${require("@images/icon/icon-hic.png")}" alt="" /> +${this.fmt_pre(item.reward)}</i>` : "") + (item.reward_spins ? `<i style="display: flex;align-items: center;"><img src="${require("@images/SPINS.png")}" alt="" /> <span style="color: #6b59d1">+${this.fmt_pre(item.reward_spins)}</span></i>` : ""),
        confirmText: setConfirmTextFnc(item),
        confirmFn: () => confirmFn(item),
        resubmission: item.completed === 1 && item.edit_costs && item.editable ? `resubmission fee is <img style="vertical-align: sub;" src="${require(`@images/icon/icon-hic.png`)}" alt="" /> <i style="color: ${this.userInfo.coin < item?.edit_costs?.coin ? '#f94144' : '#fff'}">${this.fmt_pre(item?.edit_costs?.coin)}</i>` : "",
        isConfirmLoading: item.isLoading,
        isDisableConfirm: setIsDisableConfirmFnc(item)
      };
      this.mediaInput = setMediaInputFnc(item);
      this.selectRow = JSON.parse(JSON.stringify(item));
      this.popPromptInfo = popPromptInfo;
      this.popPromptShow = true;
      console.log("itemitemitemitemitemitem", item);
    },
    async submitFrom(item) {
      if (item.isLoading) return;
      this.popPromptInfo.isConfirmLoading = item.isLoading = true;
      const params = {
        taskId: item.id,
        value: this.mediaInput
      };
      const res = await this.completeDidTask(params);
      if (!res) {
        this.popPromptInfo.isConfirmLoading = item.isLoading = false;
        return;
      }
      await this.getDidInfo(res.taskInfo);
      this.setUserInfo(res.userInfo);
      this.taskInfo.popReward.show = true;
      this.taskInfo.popReward.reward = item.reward;
      this.popPromptInfo.isConfirmLoading = item.isLoading = false;
      this.popPromptShow = false;
    },
    async editFrom(item) {
      if (item.isLoading) return;
      this.popPromptInfo.isConfirmLoading = item.isLoading = true;
      const params = {
        taskId: item.id,
        value: this.mediaInput
      };
      const res = await this.editDidTask(params);
      if (!res) {
        this.popPromptInfo.isConfirmLoading = item.isLoading = false;
        return;
      }
      this.setUserInfo(res.userInfo);
      await this.getDidInfo(res.taskInfo);
      this.$toasted.clear();
      this.$toasted.success("Edit successful!");
      this.popPromptInfo.isConfirmLoading = item.isLoading = false;
      this.popPromptShow = false;
    },
    onEdit() {
      this.$nextTick(() => {
        this.$refs.inputRef && this.$refs.inputRef.focus();
        this.isEdit = false;
        this.onShowPop(this.selectRow);
      });
    },
    onInput() {
      this.selectRow.value = this.mediaInput;
      console.log("this.selectRow.value1111", this.selectRow);
      this.onShowPop(this.selectRow);
    },
    async walletConnect(item) {
      if (this.selectRow.isLoading) return;
      this.popPromptInfo.isConfirmLoading = this.selectRow.isLoading = true;
      await this.tonWallet.connectTon();
      this.popPromptInfo.isConfirmLoading = this.selectRow.isLoading = false;
      const fnc = () => {
        if (this.tonConnect) {
          this.selectRow.value = this.tonWallet.uiAddress;
          this.onShowPop(this.selectRow);
        }
        this.tonnectTimer = setTimeout(fnc, 1000);
      };
      fnc();
    },
    async onTonnectQuit() {
      this.selectRow.value = "";
      await this.tonWallet.disconnect();
      this.onShowPop(this.selectRow);
    },
    async onFacePass() {
      await this.getDidInfo();
    }
  },
  mounted() {
    this.setWowAnim();
  }
};